/* Keep the product gallery on the style selected in either bundle slot. */
(function () {
  'use strict';
  var config = document.getElementById('audit-1010-gallery-config');
  if (!config || window.__studioGallerySync) return;
  window.__studioGallerySync = true;
  var data = JSON.parse(config.textContent);
  var mediaByVariant = {};
  data.variants.forEach(function (v) { mediaByVariant[String(v.id)] = String(v.media); });
  function showSelection(bundle, slotIndex) {
    if (!bundle.state || !bundle.state.slots[slotIndex]) return;
    var variant = bundle.resolve(bundle.state.slots[slotIndex]);
    var media = variant && mediaByVariant[String(variant.i)];
    if (!media || media === '0') return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var slide = gallery.querySelector('.product__media-item[data-media-id$="-' + media + '"]');
    if (!slide) return;
    if (typeof gallery.setActiveMedia === 'function') {
      // Native gallery uses smooth scrolling, exposing unrelated intermediate styles.
      // Settle the selected media immediately after its native queued update.
      gallery.setActiveMedia(slide.dataset.mediaId, false);
      window.setTimeout(function () {
        if (!slide.classList.contains('is-active')) return;
        slide.parentElement.scrollTo({left: slide.offsetLeft, behavior: 'instant'});
      }, 0);
    }
    else {
      var thumb = gallery.querySelector('[data-target="' + slide.dataset.mediaId + '"] button');
      if (thumb) thumb.click();
    }
  }
  function init() {
    document.querySelectorAll('fish-bundle').forEach(function (bundle) {
      var vm = document.getElementById('fish-vm-' + bundle.dataset.sectionId);
      if (!vm || JSON.parse(vm.textContent).productId !== data.productId || bundle.__studioGalleryBound) return;
      bundle.__studioGalleryBound = true;
      bundle.addEventListener('click', function (event) {
        var pill = event.target.closest('.fish-pill');
        if (pill && !pill.disabled) showSelection(bundle, Number(pill.dataset.slot));
        else if (event.target.closest('[data-tier]')) showSelection(bundle, 0);
      });
    });
  }
  function ready() { customElements.whenDefined('fish-bundle').then(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
